import { requisitionsHeaderStyles } from "@insite/content-library/Widgets/Requisitions/RequisitionsHeader";
import { requisitionsProductListStyles } from "@insite/content-library/Widgets/Requisitions/RequisitionsProductList";
import { requisitionsProductListLineStyles } from "@insite/content-library/Widgets/Requisitions/RequisitionsProductListLine";
import { COLORS } from "@tCentro/theme/design";
import { css } from "styled-components";


requisitionsHeaderStyles.approveButton = {
    mergeCss:true,
    css: css`
        margin-left: 10px;
    `,
}

requisitionsHeaderStyles.titleText = {
    variant: "h3",
        css: css`
            margin-bottom: 15px !important;
            @media print {
                font-size: 11px;
            }
        `,
}

requisitionsHeaderStyles.narrowOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            button {
                min-width: 100%;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `,
    },
}

requisitionsProductListStyles.selectAllCheckbox = {
    css: css`
        margin-left: 20px;
        span[role=checkbox] {
            border: 2px solid #9E9D9E !important;
            border-radius: 0 !important;
            &:focus {
                box-shadow: none !important;
            }
            &[aria-checked=true]{
                background: none !important;
                color: ${COLORS.black} !important;
                border: 2px solid ${COLORS.black} !important;
            }
        }
    `,
}

requisitionsProductListLineStyles.selectedCheckbox = {
    css: css`
        margin-right: 10px;
        span[role=checkbox] {
            border: 2px solid #9E9D9E !important;
            border-radius: 0 !important;
            &:focus {
                box-shadow: none !important;
            }
            &[aria-checked=true]{
                background: none !important;
                color: ${COLORS.black} !important;
                border: 2px solid ${COLORS.black} !important;
            }
        }
    `,
}